import { render, staticRenderFns } from "./MiniPie.vue?vue&type=template&id=defd5c84&scoped=true"
import script from "./MiniPie.vue?vue&type=script&lang=js"
export * from "./MiniPie.vue?vue&type=script&lang=js"
import style0 from "./MiniPie.vue?vue&type=style&index=0&id=defd5c84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defd5c84",
  null
  
)

export default component.exports